import { secondsToFullString, useElementSize } from '@mote/helpers'
import type { AudioWaveformProps } from '../Audiowaveform'
import { AudioWaveform, getWaveWidth } from '../Audiowaveform'
import { useSlider } from '../slider'
import {
  StyledWaveformScrubber,
  WaveformScrubberElapsed,
  WaveformScrubberThumb,
  WaveformScrubberTrack
} from './WaveformScrubber.styles'

export interface WaveformScrubberProps {
  waveformData: number[]
  currentTime: number
  duration: number
  onSeek: (time: number) => void
  onSeekEnd?: (time: number) => void
  size: AudioWaveformProps['size']
}

export function WaveformScrubber(props: WaveformScrubberProps) {
  const slider = useSlider({
    'aria-label': 'Audio timeline',
    value: Number(props.currentTime.toFixed(2)),
    min: 0,
    max: props.duration,
    getAriaValueText: (value: number) => secondsToFullString(value),
    onChange: props.onSeek,
    onChangeEnd: props.onSeekEnd,
    focusThumbOnChange: false
  })
  const { ref, width } = useElementSize<HTMLDivElement>()
  const numberOfBars = Math.round(width / getWaveWidth(props.size))

  return (
    <StyledWaveformScrubber {...slider.getRootProps({}, ref)}>
      <WaveformScrubberTrack {...slider.getTrackProps()}>
        <AudioWaveform
          data={props.waveformData}
          numberOfBars={numberOfBars}
          variant={'normal'}
          width={`${width}px`}
          size={props.size}
        />
        <WaveformScrubberElapsed {...slider.getInnerTrackProps()}>
          <AudioWaveform
            data={props.waveformData}
            width={`${width}px`}
            numberOfBars={numberOfBars}
            variant={'elapsed'}
            size={props.size}
          />
        </WaveformScrubberElapsed>
      </WaveformScrubberTrack>
      <WaveformScrubberThumb {...slider.getThumbProps()} />
      <input {...slider.getInputProps()} />
    </StyledWaveformScrubber>
  )
}
